import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Paper } from '@mui/material';

interface Props {
  height?: string;
}

export const EmptyPage: React.FC<Props> = ({ height }) => (
  <Paper className='emptypage' style={{ height }}>
    <ErrorOutlineIcon className='emptypage_icon' />
    <div>조회된 데이터가 없습니다.</div>
  </Paper>
);
